<template lang="pug">
.mycard(:class="{ 'mycard--linked': isMypageLinked }")
    .mycard__inner
        .mycard__barcode
            CardBarcode(v-if="authStore.LINELoginData?.cardNumber" :card-number="authStore.LINELoginData?.cardNumber")
            span.mycard__linkStatus(:class="isMypageLinked ? 'mycard__linkStatus--linked' : 'mycard__linkStatus--notLinked'")
                | {{ isMypageLinked ? 'マイページ連携済' : 'マイページ未連携' }}
        .mycard__info
            .mycard__infoText(v-if="!isMypageLinked")
                p.mycard__infoLine 下の「マイページ連携はこちら」から、
                p.mycard__infoLine 新規会員登録またはログインをお願いいたします。
                p.mycard__infoService
                    span.mycard__infoLine マイページと連携すると、各種サービスがご利用いただけます。
            p.mycard__infoNotice
                span.mycard__infoLine 会員証はALBION、IGNIS、Eléganceどのブランドでも
                span.mycard__infoLine ご利用いただけます。
</template>

<script setup>
    import { useAuth } from '@/store/auth'
    import CardBarcode from '@/components/atoms/CardBarcode.vue'

    defineProps({
        isMypageLinked: {
            type: Boolean,
            default: false,
        },
    })

    const authStore = useAuth()
</script>

<style scoped lang="stylus">
.mycard
    margin-top: 4rem
    margin-bottom: 3.2rem
    background: #fff
    background-repeat: no-repeat
    background-position: center bottom
    background-size: 100% auto
    border-radius: 20px
    box-shadow: 0px 10px 30px rgba(0, 0, 0, .15)

    +sp()
        margin-top: 3.2rem

    .mycard__inner
        display: flex
        align-items: center
        justify-content: space-around
        padding: 6rem 1.6rem 10rem

        +sp()
            flex-direction: column
            align-items: stretch
            gap: 1.4rem
            padding: 3.2rem 2rem 4rem

    // 連携済は案内文・サービス案内が非表示になるため、未連携時の高さ相当を下余白に加算して白枠下端を揃える
    &.mycard--linked
        .mycard__inner
            +sp()
                padding-bottom: calc(4rem + 1.6rem + .95rem * 1.6 * 2 + .8rem + .72rem * 1.6)

    .mycard__barcode
        display: flex
        flex-direction: column
        align-items: center
        width: 100%

    .mycard__info
        width: 100%

    .mycard__linkStatus
        display: inline-flex
        align-items: center
        justify-content: center
        margin-top: 1.6rem
        padding: .6rem 1.6rem
        border-radius: 9999px
        font-size: 1.2rem
        line-height: 160%
        letter-spacing: .04em
        font-weight: 400
        white-space: nowrap

    .mycard__linkStatus--notLinked
        color: #8B3A3A
        background-color: #F5E6E6
        border: 1px solid #C45C5C

    .mycard__linkStatus--linked
        color: #282828
        background-color: #fff
        border: 1px solid #282828

    .mycard__infoLine
        display: block
        text-align: center
        white-space: nowrap

    .mycard__infoText
        font-size: .95rem
        line-height: 160%
        letter-spacing: .04em
        font-style: normal
        font-weight: 300
        margin-top: 1.6rem

    .mycard__infoService
        font-size: .72rem
        line-height: 160%
        letter-spacing: .02em
        font-weight: 300
        margin-top: .8rem

    .mycard__infoNotice
        font-size: .88rem
        line-height: 140%
        letter-spacing: .02em
        font-style: normal
        font-weight: 400
        margin-top: 1.6rem
</style>
